import { Box, ButtonBase } from '@mui/material';
import styled from 'styled-components';

export const Sidebar = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  padding: 1rem;
  overflow: auto;
  flex: 0 0 17.5rem;
  border-left: 1px solid ${({ theme }) => theme.palette.grey['300']};
`;

export const SidebarCard = styled(Box)(({ theme }) => ({
  width: '100%',
  padding: '0.5rem 0.5rem 0 0.5rem',
  display: 'flex',
  flexDirection: 'column',
  borderRadius: theme.shape.borderRadius,
  border: `1px solid ${theme.palette.grey[500]}`,
  backgroundColor: theme.palette.common.white,
  maxHeight: '14rem',
  overflowY: 'scroll'
}));

export const SidebarItem = styled(ButtonBase)(({ theme }) => ({
  width: '100%',
  padding: '.4rem',
  borderRadius: theme.shape.borderRadius,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
  backgroundColor: 'transparent',
  transition: 'background-color .1s linear',
  cursor: 'pointer',

  '&:hover': {
    backgroundColor: theme.palette.grey['100']
  }
}));

export const SidebarWarningItem = styled(Box)(({ theme }) => ({
  fontSize: '0.69rem',
  width: '100%',
  marginBottom: '.3rem',
  padding: '.3rem',
  borderRadius: theme.shape.borderRadius,
  display: 'flex',
  alignItems: 'center',
  backgroundColor: 'transparent',
  color: theme.palette.error.main
}));

export const SidebarHeader = styled(Box)(({ theme }) => ({
  color: theme.palette.grey[600],
  marginBottom: '0.3rem',
  display: 'flex',
  alignItems: 'center',
  fontSize: '0.625rem'
}));

export const SidebarHeaderIcon = styled(Box)(({ theme }) => ({
  height: '1.25rem',
  width: '1.25rem',
  fill: theme.palette.grey[600],
  marginRight: '.078rem'
}));

export const StatusIndicator = styled(Box)({
  boxSizing: 'content-box',
  flex: '0 0 auto',
  borderRadius: '50%',
  height: '0.75rem',
  width: '0.75rem',
  marginRight: '0.65rem'
});

export default Sidebar;
